import { customerFormatForAttachment } from "../../../../utils/customer.utils";
import MoneyReceiptListPage from "../../../MoneyReceiptList";

export default function CustomerMoneyReceipt({ data }) {
  const customer = data?.old ? customerFormatForAttachment(data?.old) : {};

  return (
    <MoneyReceiptListPage
      isBreadCrumbs={false}
      style={{ hasCardBg: false, pageLayoutClassName: "", contentContainerClassName: "" }}
      customer={customer}
      isCustomer={true}
    />
  );
}
